import { LinkTracking } from '../context/tracking';
import { track } from '../track/track';

interface Payload extends LinkTracking {
  id: string;
  name?: string;
  fileName?: string;
  headline?: string;
  onTrack?: () => void;
}

export const trackMetaCard = ({
  id,
  name,
  headline,
  fileName,
  linkType,
  linkHref,
  linkText,
  onTrack,
}: Payload): void => {
  track(
    'event.metacard',
    { id, name, headline, fileName, linkType, linkHref, linkText },
    { callback: onTrack, once: false }
  );
};
